import { Configuration } from "@/model/data/security/Configuration";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";
import { AxiosResponse } from "axios";

export class GetSecurityEventConfigurationResData extends ApiGenericResponse {
    eventConfiguration: Configuration;
    rollsProfile: RollProfile;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.EventConfiguration) {
            this.eventConfiguration = new Configuration();
            this.eventConfiguration.parse(obj.EventConfiguration);
        }

        if (obj.InstallationRollsProfile) {
            this.rollsProfile = new RollProfile();
            this.rollsProfile.parse(obj.InstallationRollsProfile);
        }
    }
}
